import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import useAuth from "src/hooks/useAuth";
import { Query } from "src/types/query";
import axios from "src/utils/axios";

export interface EnvInfos {
    host: string;
    replicaHost: string;
    db: string;
}

export const useQueryEnvInfos = (): UseQueryResult<EnvInfos, unknown> => {
    const { user } = useAuth();

    return useQuery({
        queryKey: [Query.User, user.id],
        queryFn: async () => (await axios.get(`/env-infos`)).data,
    });
};
